import { ACTIONS, IAppActionInitData } from "app/store/actions"
import { Action, Reducer } from "redux"
import { ITagState } from "../model"
import { ITagActionAddUserTag, ITagActionDeleteUserTag } from "./actions"
import { getDefaultTagState } from "./state"

export const tagReducer: Reducer<ITagState, Action> = (state: ITagState | undefined, action: Action): ITagState => {
  if (!state) {
    state = getDefaultTagState()
  }
  switch (action.type) {
    case ACTIONS.APP_INIT_DATA: {
      const { userTags } = action as IAppActionInitData
      return {
        ...state,
        userTags
      }
    }

    case ACTIONS.TAG_ADD_USER_TAG: {
      const { userTag } = action as ITagActionAddUserTag
      return {
        ...state,
        userTags: [...state.userTags, userTag]
      }
    }

    case ACTIONS.TAG_DELETE_USER_TAG: {
      const { userTagId } = action as ITagActionDeleteUserTag
      return {
        ...state,
        userTags: state.userTags.filter(t => t.id !== userTagId)
      }
    }

    case ACTIONS.USER_LOGOUT: {
      return getDefaultTagState()
    }

    default:
      return state
  }
}
